import { ReactNode } from 'react';
import DashboardLayout from './dashboard';
import LogoOnlyLayout from './LogoOnlyLayout';
import AdminLayout from './global';

type Props = {
  children: ReactNode;
  variant?: 'dashboard' | 'logoOnly' | 'global';
};

export default function Layout({ variant = 'dashboard', children }: Props) {
  // 500, パスワードリセットでのみ使われている
  if (variant === 'logoOnly') {
    return <LogoOnlyLayout> {children} </LogoOnlyLayout>;
  }
  // 組織設定関連で使われる
  if (variant === 'global') {
    return <AdminLayout> {children} </AdminLayout>;
  }

  return <DashboardLayout>{children}</DashboardLayout>;
}
